import { render } from "./quoteFour.vue?vue&type=template&id=df10448a"
import script from "./quoteFour.vue?vue&type=script&lang=js"
export * from "./quoteFour.vue?vue&type=script&lang=js"

import "./quoteFour.vue?vue&type=style&index=0&id=df10448a&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__